import React from "react"
import { OrgAuthCheck } from "../../../Components/Common/AuthCheck/OrgAuthCheck"
import { defaultWorkerGroupSort } from "../../../Components/Views/Dashboard/Sections/Worker/Common/constants"
import { WorkerGroupList } from "../../../Components/Views/Dashboard/Sections/Worker/WorkerGroupList"
import { OrgRouteComponentProps } from "../../RouteProps"

export function WorkerGroupAddRoute({ match }: OrgRouteComponentProps<{}>) {
    return (
        <OrgAuthCheck
            orgUsername={match.params.orgUsername}
            scope="worker:invite"
        >
            <WorkerGroupList
                orgUsername={match.params.orgUsername}
                showAddModal={true}
                sort={defaultWorkerGroupSort}
            />
        </OrgAuthCheck>
    )
}
